import LayoutWrapper from './LayoutWrapper';

export default LayoutWrapper;
